import { render } from "./chatbot.vue?vue&type=template&id=62d6d6f0&scoped=true"
import script from "./chatbot.vue?vue&type=script&lang=js"
export * from "./chatbot.vue?vue&type=script&lang=js"

import "./chatbot.vue?vue&type=style&index=0&id=62d6d6f0&scoped=true&lang=css"
import "./chatbot.vue?vue&type=style&index=1&id=62d6d6f0&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\BrikTokApi\\BrikTokAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d6d6f0"]])

export default __exports__